/* eslint-disable prefer-destructuring */
/* eslint-disable no-shadow */

const state = {
	'query/banners': {},
};

const getters = {
	'query/banners': state => state['query/banners'],
};

const mutations = {
	'BANNERS/SET_QUERY_FILTER': function (state, filter) {
		state['query/banners'] = filter;
	},
	'BANNERS/RESET_ALL_FILTERS': function (state) {
		state['query/banners'] = {};
	},
};

const actions = {
	'banners/list': async function ({ dispatch, commit }, { reset = false }) {
		commit('SET_DATA_LOADING', { value: true, type: 'banners' });

		const { data } = await this.$http.get('https://app.michollo.com/api/banners');

		const result = {
			ok: false,
			state: 'complete',
			total: (data.banner && data.banner.length) || 0,
		};

		if (data.ok) {
			result.ok = true;

			dispatch('addData', { data: { results: data.banner, total: data.banner.length }, type: 'banners', reset });

			result.state = 'loaded';
		}

		commit('SET_DATA_LOADING', { value: false, type: 'banners' });

		return result;
	},
};

export default {
	state,
	getters,
	actions,
	mutations,
};
